var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

/*!
 * u.js - Version 0.34.1
 * micro framework, utility library
 * Author: Steve Ottoz <so@dev.so>
 * Build date: 2017-08-21
 * Copyright (c) 2017 Steve Ottoz
 * Released under the MIT license
 */
!function (a, b) {
  "use strict";

  /^f/.test("undefined") && undefined.amd ? undefined("ujs", [], b) : /^o/.test("object") ? exports = b() : a.u = a.ujs = a.µ = b();
}(/^u/.test(typeof window) ? exports : window, function (a) {
  "use strict";

  function b(b) {
    c.push.apply(this || _global, b && (b.nodeType || /^o/.test(typeof b)) && !u.isArray(b) && null !== b ? [b] : u.isArray(b) ? b : "" + b === b ? u.isHtml(b) ? u.toHtml(b) : document.querySelectorAll(b) : a);
  }

  var c = [],
      d = "prototype",
      u = function (a) {
    return /^f/.test(typeof a) ? /c/.test(document.readyState) ? a() : u._defInit.push(a) : new b(a);
  };

  u.each = function (a, b) {
    for (var c in a) a.hasOwnProperty(c) && b.call(a[c], c, a[c]);

    return a;
  }, u.extend = function (a) {
    var b,
        c,
        d = arguments;
    if (d[1] || (d[1] = a, a = u), /^f/.test(typeof Object.assign)) Object.assign.apply(Object, d);else for (b in d) if (b > 0) for (c in d[b]) d[b].hasOwnProperty(c) && (a[c] = d[b][c]);
    return a;
  }, u.trim = function (a) {
    return a.trim();
  }, u.debounce = function (a, b, c) {
    var d = null;
    return b = b || 250, function () {
      var e = c || this || _global,
          f = arguments;
      clearTimeout(d), d = setTimeout(function () {
        a.apply(e, f);
      }, b);
    };
  }, u.throttle = function (a, b, c) {
    var d, e;
    return b = b || 250, function () {
      var f = c || this || _global,
          g = +new Date(),
          h = arguments;
      d && d + b > g ? (clearTimeout(e), e = setTimeout(function () {
        d = g, a.apply(f, h);
      }, b)) : (d = g, a.apply(f, h));
    };
  }, u.type = function (a) {
    return Object.prototype.toString.call(a).replace(/^\[object (.+)\]$/, "$1").toLowerCase();
  }, u.each("push pop shift unshift filter map splice".split(" "), function (a, b) {
    u[b] = function (a, c) {
      return a[b](c);
    };
  }), u.inArray = function (a, b) {
    return b.indexOf(a);
  }, u.isArray = function (a) {
    return Array.isArray(a);
  }, u.toArray = u.makeArray = function (a) {
    return c.slice.call(a);
  }, u.toDash = function (a) {
    return a.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  }, u.toCamel = function (a) {
    return a.toLowerCase().replace(/\b-([a-z])/g, function (a, b) {
      return b.toUpperCase();
    });
  }, u.isHtml = function (a) {
    return /<[a-z][\s\S]*>/i.test(a);
  }, u.toHtml = function (a, b) {
    return b = document.createElement("div"), b.innerHTML = a, a ? b.childNodes : [];
  }, u.bytes = function (a) {
    return ~-encodeURI(a).split(/%..|./).length;
  }, u.uuid = function h(a) {
    return a ? (a ^ 16 * Math.random() >> a / 4).toString(16) : ([10000000] + -1000 + -4000 + -8000 + -100000000000).replace(/[018]/g, h);
  }, u.rid = function (a, b) {
    return b = b || 16, Array(a || 32).join(0).replace(/./g, function () {
      return (0 | Math.random() * b).toString(b);
    });
  }, u.prfx = function i(a, b, c, d) {
    for (d ? d = b.toUpperCase() : b = 4; !d && b--; d = (d = d.replace(/-(.)/g, i)) in new Image().style && d) d = [["Moz-", "Webkit-", "Ms-", "O-"][b]] + a;

    return d || a;
  }, u.stop = function (a) {
    return a.preventDefault ? a.preventDefault() : a.returnValue = !1, a;
  }, u.param = function (a, b, c) {
    if (!/^o/.test(typeof a)) return a;
    if (b) return JSON.stringify(a);
    var d = [];

    for (var e in a) {
      var f = c ? c + "[" + e + "]" : e,
          g = a[e];
      a.hasOwnProperty(e) && d.push("object" == typeof g ? u.param(g, b, f) : encodeURIComponent(f) + "=" + encodeURIComponent(g));
    }

    return d.join("&");
  }, u.parse = function (a) {
    try {
      return JSON.parse(a);
    } catch (b) {
      return a;
    }
  }, u.tpl = function (a, b) {
    return a.replace(/{{*([^}]+)*}}/g, function (a, c) {
      return a = b, c.replace(/[^.]+/g, function (b) {
        a = a[b] || "";
      }), a;
    });
  }, u.ajax = {
    opts: {
      async: !0,
      json: !0,
      auth: null,
      success: function () {},
      error: function () {},
      up: function () {},
      down: function () {}
    },
    cts: {
      form: "application/x-www-form-urlencoded",
      json: "application/json"
    },
    _send: function (a, b) {
      var c = (this || _global).cts,
          d = new XMLHttpRequest(),
          e = u.param(a.data, a.json);
      return d.onreadystatechange = function () {
        4 === d.readyState && (d.status >= 200 && d.status < 400 ? a.success(u.parse(d.response || d.responseText), d.statusText) : a.error(u.parse(d.response || d.responseText), d.statusText));
      }, d.upload && (d.upload.onprogress = function (b) {
        b.lengthComputable && a.up(b.total, b.loaded);
      }), d.onprogress = function (b) {
        b.lengthComputable && a.down(b.total, b.loaded);
      }, d.open(b, a.url, a.async), d.setRequestHeader("Content-type", a.json ? c.json : c.form), d.setRequestHeader("Accept", c.json), a.headers && u.each(a.headers, function (a, b) {
        d.setRequestHeader(a, b);
      }), a.auth && d.setRequestHeader("Authorization", a.auth), d.send(e || null), d;
    },
    defaults: function (a) {
      (this || _global).opts = u.extend({}, (this || _global).opts, a);
    }
  }, u.get = function (a) {
    return a = u.extend({}, u.ajax.opts, a), a.json = !1, a.url += (a.url.match(/\?/gi) ? "&" : "?") + (u.param(a.data) || ""), u.ajax._send(a, "GET");
  };
  var e = ["post", "put", "patch", "delete", "head", "options"];
  u.each(e, function (a, b) {
    u[b] = function (a) {
      return a = u.extend({}, u.ajax.opts, a), u.ajax._send(a, b.toUpperCase());
    };
  }), u.getScript = function (a, b) {
    var c = document.createElement("script");
    c.onload = b || function () {}, c.src = a, document.head.appendChild(c).parentNode.removeChild(c);
  }, u.defer = function (a, b) {
    return a = [], {
      resolve: function () {
        for (b = arguments; a.length;) a.shift().apply({}, b);

        return a = 0, this || _global;
      },
      then: function (c) {
        return a ? a.push(c) : c.apply({}, b), this || _global;
      }
    };
  }, u.version = "0.34.1", u._defInit = [], u._id = u.uuid(), u._data = [], u._events = [], u._events._index = function (b, c) {
    return (c = b[u._id]) === a && (b[u._id] = c = u._data.push({}) - 1), (this || _global)[c] || ((this || _global)[c] = []), c;
  }, u._events.add = function (a, b, c, d, e) {
    return e = this._index(a), this._find(e, b, c).length ? !1 : ((this || _global)[e].push({
      e: b,
      fn: c,
      handler: d
    }), !0);
  }, u._events._find = function (a, b, c) {
    return (this || _global)[a].filter(function (a) {
      return a.e === b && a.fn === c;
    });
  }, u._events.remove = function (a, b, c, d, e) {
    return e = this._index(a), d = this._find(e, b, c), (this || _global)[e] = (this || _global)[e].filter(function (a) {
      return a.e !== b && a.fn !== c;
    }), d;
  }, u.fn = u[d] = b[d] = {
    length: 0,
    ujs: "0.34.1",
    each: function (a) {
      return u.each(u.toArray(this || _global), a), this || _global;
    },
    on: function (a, b, c, d) {
      return /^f/.test(typeof b) ? (c = b, d = c) : /^s/.test(typeof b) && (d = c, c = function (a) {
        var c;
        u(a.target).is(b) ? c = a.target : u(a.target).parents(b).length && (c = u(a.target).parents(b)[0]), c && d.apply(c, [a]);
      }), this.each(function (b, e) {
        var f = a.split(" ");
        u.each(f, function (a, b) {
          u._events.add(e, b, d, c) && e.addEventListener(b, c);
        });
      });
    },
    one: function (a, b, c, d) {
      return /^f/.test(typeof b) ? (c = b, d = c) : /^s/.test(typeof b) && (d = c, c = function (a) {
        var c;
        u(a.target).is(b) ? c = a.target : u(a.target).parents(b).length && (c = u(a.target).parents(b)[0]), c && d.apply(c, [a]);
      }), this.each(function (b, e) {
        var f = a.split(" ");
        u.each(f, function (a, b) {
          u._events.add(e, b, d, c), e.addEventListener(b, function f(a) {
            e.removeEventListener(b, f), u._events.remove(e, b, d), c.call(this || _global, a);
          });
        });
      });
    },
    off: function (a, b, c, d) {
      return /^f/.test(typeof b) && (c = b), d = c, this.each(function (b, e) {
        var f = a.split(" ");
        u.each(f, function (a, b, f) {
          f = u._events.remove(e, b, d), c = f.length ? f[0].handler : c, e.removeEventListener(b, c);
        });
      });
    },
    trigger: function (a, b, c) {
      return /^f/.test(typeof CustomEvent) ? c = new CustomEvent(a, {
        detail: b,
        bubbles: !0,
        cancelable: !1
      }) : (c = document.createEvent("CustomEvent"), c.initCustomEvent(a, !0, !1, b)), this.each(function (b, d) {
        d.dispatchEvent ? d.dispatchEvent(c) : d.fireEvent("on" + a, c);
      });
    },
    hasClass: function (a) {
      return (this || _global).length ? (this || _global)[0].classList.contains(a) : !1;
    },
    position: function () {
      return (this || _global).length ? {
        left: (this || _global)[0].offsetLeft,
        top: (this || _global)[0].offsetTop
      } : {
        left: 0,
        top: 0
      };
    },
    offset: function () {
      if (!(this || _global).length) return {
        top: 0,
        left: 0
      };

      var a = (this || _global)[0].getBoundingClientRect();

      return {
        top: a.top + document.body.scrollTop,
        left: a.left + document.body.scrollLeft
      };
    },
    scrollTop: function (b) {
      return b === a ? (this || _global).length ? (this || _global)[0].scrollTop !== a ? (this || _global)[0].scrollTop : (this || _global)[0].scrollY || (this || _global)[0].pageYOffset : 0 : this.each(function (c, d) {
        d.scrollTop === a || d.scrollTo !== a ? d.scrollTo(0, b) : d.scrollTop = b;
      });
    },
    scrollTo: function (a, b, c) {
      return this.each(function (d, e) {
        function f(a, b, c, d) {
          return a /= d / 2, 1 > a ? c / 2 * Math.pow(2, 10 * (a - 1)) + b : (a--, c / 2 * (-Math.pow(2, -10 * a) + 2) + b);
        }

        function g() {
          k += l;
          var a = f(k, i, j, b);
          h.scrollTop(a), b > k ? requestAnimationFrame(g) : c && c.apply(window);
        }

        var h = u(e),
            i = h.scrollTop(),
            j = a - i,
            k = 0,
            l = 20;
        b = b || 1500, g();
      });
    },
    scrollToTop: function (a, b) {
      return this.each(function (c, d) {
        u(d).scrollTo(0, a, b);
      });
    },
    width: function (b) {
      return b === a ? (this || _global).length ? (this || _global)[0].clientWidth || (this || _global)[0].innerWidth : 0 : this.each(function (a, c) {
        c.style.width = b + "px";
      });
    },
    outerWidth: function (a) {
      return (this || _global).length ? a ? (this || _global)[0].offsetWidth + parseInt(getComputedStyle((this || _global)[0]).marginLeft) + parseInt(getComputedStyle((this || _global)[0]).marginRight) : (this || _global)[0].offsetWidth : 0;
    },
    height: function (b) {
      return b === a ? (this || _global).length ? (this || _global)[0].clientHeight || (this || _global)[0].innerHeight : 0 : this.each(function (a, c) {
        c.style.height = b + "px";
      });
    },
    outerHeight: function (a) {
      return (this || _global).length ? a ? (this || _global)[0].offsetHeight + parseInt(getComputedStyle((this || _global)[0]).marginTop) + parseInt(getComputedStyle((this || _global)[0]).marginBottom) : (this || _global)[0].offsetHeight : 0;
    },
    hide: function () {
      return this.each(function (a, b) {
        b.style.display = "none";
      });
    },
    show: function () {
      return this.each(function (a, b) {
        b.style.display = "";
      });
    },
    attr: function (b, c) {
      return c === a ? (this || _global).length ? (this || _global)[0].getAttribute(b) : null : this.each(function (a, d) {
        d.setAttribute(b, c);
      });
    },
    removeAttr: function (a) {
      return this.each(function (b, c) {
        c.removeAttribute(a);
      });
    },
    hasAttr: function (a) {
      return (this || _global).length ? (this || _global)[0].hasAttribute(a) : !1;
    },
    prop: function (b, c) {
      return c === a ? (this || _global).length ? (this || _global)[0][b] : null : this.each(function (a, d) {
        d[b] = c;
      });
    },
    data: function (b, c, d, e, f, g) {
      return b === a ? (this || _global).length ? (d = (this || _global)[0], f = u.extend({}, d.dataset || {}), (e = d[u._id]) === a ? (d[u._id] = e = u._data.push(f) - 1, f) : u._data[e] = u.extend({}, f, u._data[e])) : {} : (g = u.toCamel(u.toDash(b)), c === a ? (this || _global).length ? (d = (this || _global)[0], (e = d[u._id]) === a ? (f = {}, f[g] = d.dataset ? d.dataset[g] : d.getAttribute("data-" + b), d[u._id] = e = u._data.push(f) - 1, f[g]) : u._data[e][g] ? u._data[e][g] : u._data[e][g] = d.dataset ? d.dataset[g] : d.getAttribute("data-" + b)) : null : this.each(function (b, d) {
        (b = d[u._id]) === a ? (f = {}, f[g] = c, d[u._id] = b = u._data.push(f) - 1) : u._data[b][g] = c;
      }));
    },
    removeData: function (b, c, d) {
      return this.each(function (e, f) {
        b !== a && (d = u.toCamel(u.toDash(b)), (c = f[u._id]) !== a && (f.dataset ? delete f.dataset[d] : f.removeAttribute("data-" + b), delete u._data[c][d]));
      });
    },
    css: function (b, c) {
      if (/^o/.test(typeof b)) {
        for (var d in b) {
          var e = u.prfx(d);
          b.hasOwnProperty(d) && this.each(function (a, c) {
            c.style[e] = b[d];
          });
        }

        return this || _global;
      }

      return c === a ? (this || _global).length ? getComputedStyle((this || _global)[0])[b] : null : this.each(function (a, d) {
        var e = u.prfx(b);
        d.style[e] = c;
      });
    },
    append: function (a) {
      return this.each(function (b, c) {
        a.each(function (a, b) {
          c.appendChild(b);
        });
      });
    },
    prepend: function (a) {
      return this.each(function (b, c, d) {
        d = c.firstChild, a.each(function (a, b) {
          c.insertBefore(b, d);
        });
      });
    },
    before: function (a) {
      return this.each(function (b, c) {
        a.each(function (a, b) {
          c.insertAdjacentHTML("beforebegin", b.outerHTML);
        });
      });
    },
    after: function (a) {
      return this.each(function (b, c) {
        a.each(function (a, b) {
          c.insertAdjacentHTML("afterend", b.outerHTML);
        });
      });
    },
    first: function () {
      return (this || _global).length ? u((this || _global)[0]) : this || _global;
    },
    last: function () {
      return (this || _global).length ? u((this || _global)[(this || _global).length - 1]) : this || _global;
    },
    eq: function (a) {
      return u((this || _global)[a]);
    },
    get: function (a) {
      return (this || _global)[a];
    },
    clone: function () {
      return (this || _global).length ? u((this || _global)[0].cloneNode(!0)) : this || _global;
    },
    contains: function (a) {
      return (this || _global).length ? /^o/.test(typeof a) ? (this || _global)[0] !== a[0] && (this || _global)[0].contains(a[0]) : null !== (this || _global)[0].querySelector(a) : !1;
    },
    find: function (a) {
      return (this || _global).length ? u(u.toArray((this || _global)[0].querySelectorAll(a))) : this || _global;
    },
    filter: function (a) {
      return u(c.filter.call(this || _global, function (b, c) {
        return /^f/.test(typeof a) ? a(c, b) : u(b).is(a);
      }));
    },
    is: function (a) {
      if (!(this || _global).length) return !1;

      var b = (this || _global)[0].matches || (this || _global)[0].matchesSelector || (this || _global)[0].msMatchesSelector || (this || _global)[0].mozMatchesSelector || (this || _global)[0].webkitMatchesSelector || (this || _global)[0].oMatchesSelector || function (a) {
        return -1 !== [].indexOf.call(document.querySelectorAll(a), this || _global);
      };

      return b.call((this || _global)[0], a);
    },
    children: function () {
      return (this || _global).length ? u(u.toArray((this || _global)[0].children)) : this || _global;
    },
    index: function (a) {
      return a ? "" + a === a ? u.toArray(u(a)).indexOf((this || _global)[0]) : (a = a.ujs ? a[0] : a, u.toArray(this || _global).indexOf(a)) : (this || _global)[0] ? this.first().prevAll().length : -1;
    },
    prev: function (a) {
      return (this || _global).length ? u(u.toArray(this.prevAll(a)).shift()) : this || _global;
    },
    prevAll: function (a) {
      if (!(this || _global).length) return this || _global;

      for (var b = [], c = (this || _global)[0]; c = c.previousElementSibling;) a ? u(c).is(a) && b.push(c) : b.push(c);

      return u(b);
    },
    next: function (a) {
      return (this || _global).length ? u(u.toArray(this.nextAll(a)).shift()) : this || _global;
    },
    nextAll: function (a) {
      if (!(this || _global).length) return this || _global;

      for (var b = [], c = (this || _global)[0]; c = c.nextElementSibling;) a ? u(c).is(a) && b.push(c) : b.push(c);

      return u(b);
    },
    siblings: function (a) {
      if (!(this || _global).length) return this || _global;
      var b = (this || _global)[0];
      return u(c.filter.call(b.parentNode.children, function (c) {
        return a ? c !== b && u(c).is(a) : c !== b;
      }));
    },
    parent: function () {
      return (this || _global).length ? u((this || _global)[0].parentNode) : this || _global;
    },
    parents: function (b) {
      if (!(this || _global).length) return this || _global;

      for (var c = [], d = !1, e = (this || _global)[0]; !d;) e = e.parentNode, e ? b === a ? c.push(e) : u(e).is(b) && c.push(e) : d = !0;

      return u(c);
    },
    text: function (b) {
      return b === a ? (this || _global).length ? (this || _global)[0].textContent : null : this.each(function (a, c) {
        c.textContent = b;
      });
    },
    html: function (b) {
      return b === a ? (this || _global).length ? (this || _global)[0].innerHTML : null : this.each(function (a, c) {
        c.innerHTML = b;
      });
    },
    outerHTML: function (b) {
      return b === a ? (this || _global).length ? (this || _global)[0].outerHTML : null : this.each(function (a, c) {
        c.outerHTML = b;
      });
    },
    val: function (b) {
      return b === a ? (this || _global).length ? (this || _global)[0].value : null : this.each(function (a, c) {
        c.value = b;
      });
    },
    empty: function () {
      return this.each(function (a, b) {
        b.innerHTML = "";
      });
    },
    remove: function () {
      return this.each(function (a, b) {
        b.parentNode.removeChild(b);
      });
    },
    bytes: function () {
      return (this || _global).length ? u.bytes((this || _global)[0].value || (this || _global)[0].textContent) : 0;
    },
    toArray: function () {
      return u.toArray(this || _global);
    },
    focus: function () {
      return (this || _global).length && (this || _global)[0].focus(), this || _global;
    },
    blur: function () {
      return this.each(function (a, b) {
        b.blur();
      });
    },
    extend: function () {
      var a = u.toArray(arguments);
      return a.unshift(u.fn), u.extend.apply(this || _global, a);
    },
    splice: c.splice
  };
  var f = ["addClass", "removeClass", "toggleClass"],
      g = ["add", "remove", "toggle"];
  return u.each(f, function (b, c) {
    u[d][c] = function (c, d) {
      return this.each(function (e, f) {
        var h = c.split(" ");
        u.each(h, function (c, e, h) {
          h = d !== a ? [e, !!d] : [e], f.classList[g[b]].apply(f.classList, h);
        });
      });
    };
  }), /^u/.test(typeof document) || u(document).on("DOMContentLoaded", function (a) {
    for (var b in u._defInit) u._defInit.hasOwnProperty(b) && u._defInit[b](a);

    u._defInit = [];
  }), u;
}); //# sourceMappingURL=u.min.js.map

export default exports;